module.exports = __webpack_public_path__ + "static/media/becoming-tutor-img3.431d566f.jpg";